/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_AccionAsync as AccionAsync,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_Wr as Wr,
  rec_yQ as yQ,
} from "../../runtime/index.jsx";
export function DocumentoMensaje({ m: e, cliente: t }) {
  let n = e.tipo === `imagen` || e.tipo === `sticker`,
    [r, i] = (0, React.useState)(null),
    [a, o] = (0, React.useState)(!1),
    [s, c] = (0, React.useState)(``),
    l = (0, React.useCallback)(async () => {
      o(!0);
      try {
        i(await t.archivo(e.id));
      } catch {
        c(`No se pudo abrir`);
      } finally {
        o(!1);
      }
    }, [t, e.id]);
  return (
    (0, React.useEffect)(() => {
      n && l();
    }, [n, l]),
    (0, React.useEffect)(
      () => () => {
        r && URL.revokeObjectURL(r);
      },
      [r],
    ),
    s ? (
      <p className={`text-xs text-(--error-texto)`} children={s} />
    ) : r ? (
      n ? (
        <a
          href={r}
          target={`_blank`}
          rel={`noreferrer`}
          children={
            <img
              src={r}
              alt={e.texto || `Foto`}
              className={`max-h-72 rounded-lg`}
            />
          }
        />
      ) : e.tipo === `audio` ? (
        <audio controls={!0} src={r} className={`max-w-full`} />
      ) : e.tipo === `video` ? (
        <video
          controls={!0}
          src={r}
          className={`max-h-72 max-w-full rounded-lg`}
        />
      ) : (
        <a
          href={r}
          download={e.nombreArchivo || `archivo`}
          className={`inline-flex items-center gap-1 text-(--accent-texto) underline`}
          children={[
            <Wr className={`h-4 w-4`} />,
            e.nombreArchivo || `Documento`,
          ]}
        />
      )
    ) : n ? (
      <div className={`h-40 w-56 animate-pulse rounded-lg bg-(--border)`} />
    ) : (
      <AccionAsync
        variante={`secundario`}
        className={`min-h-9 text-xs`}
        disabled={a}
        onClick={l}
        children={[yQ(e.tipo), e.segundos ? ` · ${e.segundos} s` : ``]}
      />
    )
  );
}
